import React from 'react'
import '@/sass/about.scss';
import resume from '@/cv.pdf';
import Card from 'components/layouts/Card';
import * as Technology from 'components/constant/Technology';

interface IState {
    name: string,
    job: string,
    domicile: string,
    team: string,
    company: string,
    btnText: string,
    header1: string,
    header2: string,
    header3: string,
    technologies: string[],
}

function createMarkup(text: string) {
    return {__html: text};
}

const firstPharagraph = (content: string[]) => {
    return (
        <div className="content-container col-12">
            {content.map((x, i) => {
                if (x.includes("</span>")) {
                    return <div key={i} className="content-text" dangerouslySetInnerHTML={createMarkup(x)} />;
                }
                return <div key={i} className="content-text">{x}</div>
            })}
        </div>
    )
}

const secondParagraph = (technologies: string[]) => {
    return (
        technologies.map(x => {
            const tech = Technology.Technologies[x]
            return (
                <Card key={x} 
                    image={tech.getImage().getSource()} 
                    imageName={tech.getName()} 
                    content={tech.getName()} />
            )
        })
    )
}

class About extends React.Component<{}, IState> {
    constructor(props: {}) {
        super(props)
        this.state = {
            name: "James Riady",
            job: "Full-stack Web Developer",
            domicile: "Jakarta, Indonesia",
            team: "Games Team",
            company: "Shopee Indonesia",
            btnText: "Download CV",
            header1: "Who is James Riady?",
            header2: "What Technologies are used?",
            header3: "Want to know more about him?",
            technologies: [
                Technology.HTML,
                Technology.CSS,
                Technology.JAVASCRIPT,
                Technology.JAVA,
                Technology.MYSQL,
                Technology.VUE,
                Technology.REACT,
                Technology.LARAVEL,
                Technology.GO,
                Technology.GIT
            ]
        }
    }

    render() {
        const content = [
            `${this.state.name} is a ${this.state.job} based in ${this.state.domicile}.`,
            "Being a developer is something challenging and he enjoys taking challenging projects.",
            `He is currently part of ${this.state.team} at <span>${this.state.company}</span> that handles variety of games.`
        ];

        return (
            <div id="about" className="about">
                <div className="container">
                    <img className="left-dot" src={require("@/images/about_dot.svg")} />
                    <div className="biodata">
                        <div className="row justify-content-center">
                            <h2 className="header col-12">{this.state.header1}</h2>
                            { firstPharagraph(content) }
                        </div>
                    </div>
                    <div className="technology">
                        <div className="row justify-content-center">
                            <h2 className="header col-12">{this.state.header2}</h2>
                            <div className="card-container">
                                { secondParagraph(this.state.technologies) }
                            </div>
                        </div>
                    </div>
                    <div className="resume">
                        <div className="row justify-content-center">
                            <h2 className="header col-12">{this.state.header3}</h2>
                            <div className="content-container col-12">
                                <a href={resume} download className="btn btn-lg btn-custom">{this.state.btnText}</a>
                            </div>
                        </div>
                    </div>
                    <img className="right-dot" src={require("@/images/about_dot.svg")} />
                </div>
            </div>
        )
    }
}

export default About